import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('assets')) {
    return next(req);
  }

  return next(req.clone({ url: `${environment.apiUrl}${req.url}` }));
};
